import {Dayjs} from "dayjs";

export const formatDateToYYYYMMDD = (dt: Date): string => {
    const date = new Date(dt);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}.${month}.${day}`;
}

export function formatDateToFullString(dt: Date): string {
    const date = new Date(dt);
    const year = date.getFullYear();
    const month = padZero(date.getMonth() + 1);
    const day = padZero(date.getDate());
    const hours = padZero(date.getHours());
    const minutes = padZero(date.getMinutes());

    return `${year}.${month}.${day} ${hours}:${minutes}`;
}

export function padZero(value: number): string {
    return value < 10 ? `0${value}` : `${value}`;
}

export const formatDateToDBFormat = (dt: Date): string => {
    const date = new Date(dt);
    const year = date.getFullYear().toString();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}

export const convertStringToDBFormat = (dateString: string): string => {
    const dt = new Date(dateString as string);
    return formatDateToDBFormat(dt);
}

export const parseDate = (date: Dayjs | null) => date?.format('YYYY-MM-DD') || null;

export const parseDateToIsoFormat = (date: Dayjs) => date?.format('YYYY-MM-DD')


export const isTodayBirthDay = (bDay: string): boolean => {
    const parts = bDay.split("-");
    const bDayMonth = Number(parts[1]);
    const bDayDate = Number(parts[2]);
    const today = new Date();
    const currMonth = today.getMonth() + 1;
    const currDate = today.getDate();
    return bDayMonth === currMonth && bDayDate === currDate;
}
